import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getDashboardInformation } from '../../redux/dashboard/dashboardActions';
import SimpleCard from '../dashboard/cards/SimpleCard';
import LoadingIndication from '../layouts/LoadingIndicator';

const HomePage = ({ dashboardInformation, getDashboardInformation }) => {
    const { diamonds, topups, users } = dashboardInformation;
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        return fetchData();
    }, []);

    const fetchData = () => {
        setLoading(true);
        getDashboardInformation();
        setLoading(false);
    }

    return (
        <div className="">
            <div className="flex w-full justify-between bg-blue-400 py-4 px-4 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                <p className="m-auto inset-0 text-xl font-semibold leading-7 text-center text-gray-200">Home</p>
            </div>
            <div className="flex flex-wrap justify-center items-center space-y-4 space-x-2 px-4 mt-10">
                {loading ? (<LoadingIndication/>) : (<>
                    <SimpleCard name="Total Diamond Card" number={diamonds && diamonds.total}/>
                    <SimpleCard name="Active Diamond Card" number={diamonds && diamonds.active}/>
                    
                    <SimpleCard name="Total TopUp" number={topups && topups.total}/>
                    <SimpleCard name="Today New TopUp" number={topups && topups.newToday}/>
                    <SimpleCard name="Pending TopUp" number={topups && topups.pending}/>
                    <SimpleCard name="Processing TopUp" number={topups && topups.processing}/>
                    <SimpleCard name="Canceled TopUp" number={topups && topups.canceled}/>
                    <SimpleCard name="Done TopUp" number={topups && topups.done}/>
                    
                    <SimpleCard name="Total Users" number={users && users.total}/>
                    <SimpleCard name="Today New Users" number={users && users.newToday}/>
                </>)}
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        dashboardInformation: state.dashboardInformation
    };
}


const mapDispatchToProps = dispatch => {
    return {
        getDashboardInformation: (latestData) => dispatch(getDashboardInformation()),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(HomePage);